// Override Settings
var bcSfSearchSettings = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function (suggestionElement, searchElement, searchBoxId) {
  console.log(this);
  console.log(suggestionElement);
};

BCSfFilter.prototype.buildSuggestionProductPrice = function (a) {
  const productID = a.id;
  this.prepareSuggestionProductPriceData(a);

  var b = a.compare_at_price_min > a.price_min
    , c = this.formatMoney(100 * a.price_min)
    , d = this.formatMoney(100 * a.compare_at_price_min);
  this.getSettingValue("search.removePriceDecimal") && (c = this.removeDecimal(c), d = this.removeDecimal(d));

  let pricesString = '';
  var e = "";

  if (window.customerMayorista && productID !== 7795427606716) {
    const originalPrice = 100 * a.price_min;
    let discountedPrice = originalPrice - (originalPrice * 0.15);
    discountedPrice = this.formatMoney(discountedPrice);
    pricesString = `<span class="bc-sf-product-sale-price customerMayorista">${discountedPrice}</span> <s>${c}</s>`;
  } else {
    if (b && this.getSettingValue("search.showSuggestionProductSalePrice")) {
      pricesString = `<span class="bc-sf-product-sale-price">${c}</span> <s>${d}</s> `;
    } else {
      pricesString = `<span class="bc-sf-product-regular-price">${c}</span>`;
    }
  }
  return this.getSettingValue("search.showSuggestionProductPrice") && 
    (
      e += '<div class="' + this.class.searchSuggestion + '-product-price">',
      e += pricesString,
        // b && this.getSettingValue("search.showSuggestionProductSalePrice") ? 
        //   (e += "<s>" + d + "</s>  ", e += '<span class="bc-sf-product-sale-price">' + c + "</span>") :
        //   e += '<span class="bc-sf-product-regular-price">' + c + "</span>",
      e += "</div>"
    ),
    e
}

/* Start Search Redirect */
function submitSearchFormMobile(t, e) { e.preventDefault(); var o = bcsffilter.getSearchRedirectUrl(bcsffilter.currentTerm); o ? window.location.href = o : jQ(t).closest("form").submit() } function beforeSubmitSearchForm(t, e) { var o = jQ(t).val(), i = bcsffilter.getSearchRedirectUrl(o); i && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault(), window.location.href = i) } BCSfFilter.prototype.setSuggestionPosition = function (t) { var e = this; if ("function" == typeof getSuggestionPosition && "function" == typeof this.checkIsFullWidthSuggestionMobile) { var o = getSuggestionPosition(t), i = this.checkIsFullWidthSuggestionMobile(t) ? "top" : "top+12"; "function" != typeof e.isSuggestionStyle2 || e.isSuggestionStyle2(), "left" == o ? jQ(t).autocomplete("option", "position", { my: "left " + i, at: "left bottom", collision: "none" }) : jQ(t).autocomplete("option", "position", { my: "right " + i, at: "right bottom", collision: "none" }) } else "left" == this.getSettingValue("search.suggestionPosition") ? jQ(t).autocomplete("option", "position", { my: "left top+12", at: "left bottom", collision: "none" }) : jQ(t).autocomplete("option", "position", { my: "right top+12", at: "right bottom", collision: "none" }); if (jQ(t).length > 0 && jQ(t).on("keydown", function (o) { 13 == o.keyCode && e.enterSearchBoxEvent(t, o) }), jQ(t).closest("form").length > 0) { var n = jQ(t).closest("form").find('[type="submit"]'); n && n.length > 0 && n.each(function (e, o) { o.setAttribute("onclick", "beforeSubmitSearchForm('" + t + "', event)") }) } }, BCSfFilter.prototype.enterSearchBoxEvent = function (t, e) { var o = jQ(t).val(), i = this.getSearchRedirectUrl(o); i && (e.preventDefault(), window.location.href = i) }, BCSfFilter.prototype.getSearchRedirectUrl = function (t) { if (this.suggestionCache && this.suggestionCache.hasOwnProperty(t)) for (var e = this.suggestionCache[t], o = 0; o < e.length; o++)if ("redirect" == e[o].key && e[o].values) { var i = e[o].values; return i = (i = i.replace("https://" + bcSfFilterMainConfig.shop.domain, "")).replace("http://" + bcSfFilterMainConfig.shop.domain, "") } return "" };
/* End Search Redirect */
